export default __webpack_public_path__ + "assets/bcefe1e01bbf99aa462894ac6a3370de.jpg";